import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import './yDialog.css';

const SIZE_CLASS = {
  sm: 'y-dialog--sm',
  md: 'y-dialog--md',
  lg: 'y-dialog--lg',
};

/**
 * Design-system dialog shell. Use with DialogFieldsRenderer + schema YAML/JS,
 * or pass children for custom bodies.
 */
export function YDialog({
  show,
  onHide,
  title,
  size = 'sm',
  children,
  footer,
  error,
  testId = 'y-dialog',
  dialogClassName = '',
  bodyClassName = '',
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName={['y-dialog', SIZE_CLASS[size] || '', dialogClassName].filter(Boolean).join(' ')}
      data-testid={testId}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={['y-dialog__body', bodyClassName].filter(Boolean).join(' ')}>
        {error ? (
          <p className="y-dialog__error" role="alert">
            {error}
          </p>
        ) : null}
        {children}
      </Modal.Body>
      {footer ? <Modal.Footer className="y-dialog__footer">{footer}</Modal.Footer> : null}
    </Modal>
  );
}

YDialog.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  title: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node,
  footer: PropTypes.node,
  error: PropTypes.string,
  testId: PropTypes.string,
  dialogClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
};
